import { Rows3, Rows4 } from 'lucide-react';
import { setDensity, useDensity } from '../lib/density.ts';
import type { Density } from '../lib/density.ts';
import { Segmented } from './Segmented.tsx';

/** Comfortable or compact rows, for every table and list at once. */
export function DensityToggle({ className }: { className?: string }) {
  const density = useDensity();
  return (
    <Segmented<Density>
      label="Row density"
      value={density}
      onChange={setDensity}
      className={className}
      options={[
        { value: 'comfortable', label: 'Comfortable rows', icon: <Rows3 />, iconOnly: true },
        { value: 'compact', label: 'Compact rows', icon: <Rows4 />, iconOnly: true },
      ]}
    />
  );
}
